import type { PredictionResponse } from 'api/__GENERATED';
import * as R from 'remeda';
import { timeUtility } from 'utility';

// Maps a single PredictionResponse DTO to Data.Projection.
// Returns undefined if unitOfMeasureId is missing — those rows can't be used downstream.
function toPrediction(dto: PredictionResponse): Data.Projection | undefined {
  const {
    id,
    tenantId,
    zoneId,
    year,
    monthNumber,
    weekNumber,
    dayOfMonth,
    dayOfWeek,
    value,
    unitOfMeasureId,
    isCreatedByUser,
    createdAt,
    updatedAt,
  } = dto;

  if (!R.isDefined(unitOfMeasureId)) return undefined;

  // `modifiedAt` lets downstream selectors order multiple predictions for
  // the same day — `timestamp` alone is the target-day key and ties.
  // Prefer `updatedAt` (last revision) and fall back to `createdAt`.
  const modifiedAt = new Date(updatedAt ?? createdAt).getTime();

  const projection: Data.Projection = {
    id,
    companyId: tenantId,
    zoneId: zoneId ?? null,
    year,
    month: monthNumber - 1,
    week: weekNumber,
    dayOfMonth,
    dayOfWeek,
    timestamp: timeUtility.toTimestamp(
      timeUtility.factory<Time.Day>({
        type: 'day',
        year,
        month: monthNumber - 1,
        dayOfMonth,
        dayOfWeek,
        week: weekNumber,
      }),
    ),
    modifiedAt,
    value,
    unitOfMeasureId,
    isSystemPrediction: !(isCreatedByUser ?? false),
  };

  return projection;
}

export { toPrediction };
